import { render, staticRenderFns } from "./BlacklistDialog.vue?vue&type=template&id=455a2181&scoped=true"
import script from "./BlacklistDialog.vue?vue&type=script&lang=js"
export * from "./BlacklistDialog.vue?vue&type=script&lang=js"
import style0 from "./BlacklistDialog.vue?vue&type=style&index=0&id=455a2181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a2181",
  null
  
)

export default component.exports